<div style="display: contents">
  <h1 *ngIf="zonaEdit == undefined && !addLuminarias" class="textM" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("zones.newZone")}}
  </h1>

  <h1 *ngIf="zonaEdit == undefined && addLuminarias" class="textM" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("zones.newZone")}} {{zonaEdit.nombre}}
  </h1>

  <h1 *ngIf="zonaEdit != undefined" class="textM" style="text-align: center; height: 10%" mat-dialog-title>
    {{this.localiser.get("zones.editZone")}}
  </h1>

  <div *ngIf="!addLuminarias" mat-dialog-content class="bodyForm">
    <div class="row rowForm">
      <div class="col">
        <h4 class="textM">{{this.localiser.get("devices.name")}}</h4>
        <input [(ngModel)]="nombre" type="text" class="inputWidth textS+" maxlength="30">
      </div>
      <div class="col">
        <h4 class="textM">{{this.localiser.get("devices.floorplan")}}</h4>
        <mat-select id="editZoneSelectFloorplan" (selectionChange)="selectPlano($event)" [(ngModel)]="planoSelected" class="selectPlano textS+"
                    [disabled]="user.getPermiso() == Roles.Ateneo">
          <mat-option class="textS+" *ngFor="let plano of planos" [value]="plano">{{plano.nombre}}</mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row rowForm">
      <div class="col">
        <h4 class="textM">{{this.localiser.get("floorplans.color")}}</h4>
        <input [(ngModel)]="color" type="color" class="inputWidth">
      </div>
      <div class="col">
        <h4 class="textM">{{this.localiser.get("floorplans.description")}}</h4>
        <textarea class="marginAuto inputWidth textS+" style="width: 80%" [(ngModel)]="descripcion" maxlength="100"></textarea>
      </div>
    </div>
    <div class="row rowForm">
      <div class="col-6">
        <h4 class="textM">{{this.localiser.get("zones.editZone.rule")}}</h4>
        <mat-select id="editZoneSelectRule" [(ngModel)]="reglaSelected" class="selectPlano textS+">
          <mat-option class="textS+" *ngFor="let regla of reglas" [value]="regla">{{regla.nombre}}</mat-option>
        </mat-select>
      </div>
    </div>

    <div *ngIf="errorMessage != ''" class="row errorMessage">
      <h4 class="textS+ marginAuto">{{this.errorMessage}}</h4>
    </div>


  </div>

  <div *ngIf="addLuminarias" mat-dialog-content class="bodyForm">
    <div class="row" style="height: 100%">
      <div class="col" style="height: 100%; border-right: 2px solid">
        <h1 class="textM" style="text-align: center">{{this.localiser.get("zones.lumsWithoutZone")}}</h1>

        <div class="row searcherDiv">
          <div class="col-10">
            <input [(ngModel)]="searcherLuminariasOut" type="text" class="centerVert textS+ searcherInput"
                   placeholder="{{this.localiser.get('devices.searcher')}}" (input)="searcherLuminariasFuncOut()" maxlength="50">
          </div>

          <div class="col-2" style="margin: inherit">
            <span class="material-icons-outlined textXXM">
              search
            </span>
          </div>
        </div>

        <div class="luminariasListScroll">

          <div *ngFor="let luminaria of this.luminariasPlano; index as i" class="luminariaBox">
            <div class="luminariaRow col-10">
              <h6 class="textS+" style="text-decoration: underline; margin: 1% auto"> {{luminaria.nombre}} </h6>
              <h6 class="textS" style="margin: 1% auto"> {{luminaria.idDispositivo}} </h6>
            </div>
            <div class="col-2">
            <span (click)="addLuminariaToZona(luminaria)" class="material-icons-outlined buttonMapAdd textXM centerVert">
                add_circle_outline
            </span>
            </div>
          </div>
        </div>

      </div>

      <div class="col" style="height: 100%">
        <h1 class="textM" style="text-align: center">{{this.localiser.get("zones.lumsInZone")}}</h1>

        <div class="row searcherDiv">
          <div class="col-10">
            <input [(ngModel)]="searcherLuminariasIn" type="text" class="centerVert textS+ searcherInput"
                   placeholder="{{this.localiser.get('devices.searcher')}}" (input)="searcherLuminariasFuncIn()" maxlength="50">
          </div>

          <div class="col-2" style="margin: inherit">
            <span class="material-icons-outlined textXXM">
              search
            </span>
          </div>
        </div>

        <div class="luminariasListScroll">

          <div *ngFor="let luminaria of this.luminariasZona; index as i" class="luminariaBox">
            <div class="luminariaRow col-10">
              <h6 class="textS+" style="text-decoration: underline; margin: 1% auto"> {{luminaria.nombre}} </h6>
              <h6 class="textS" style="margin: 1% auto"> {{luminaria.idDispositivo}} </h6>
            </div>
            <div class="col-2">
            <span (click)="removeLuminariaToZona(luminaria)" class="material-icons-outlined buttonMapRm textXM centerVert">
                remove_circle_outline
            </span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div mat-dialog-actions>
    <div class="col" style="text-align: center">
      <button class="customButtonColor textS+" mat-button (click)="onCancelClick()">{{this.localiser.get("button.close")}}</button>
    </div>
    <div *ngIf="zonaEdit != undefined" class="col" style="text-align: center">
      <button *ngIf="!addLuminarias && user.getPermiso() != Roles.Ateneo" class="customButtonColor textS+" mat-button (click)="toAddLuminarias()">{{this.localiser.get("zones.modLums")}}</button>
      <button *ngIf="addLuminarias" class="customButtonColor textS+" mat-button (click)="backToEdit()">{{this.localiser.get("zones.modInfo")}}</button>
    </div>
    <div class="col" style="text-align: center">
      <button *ngIf="zonaEdit == undefined && !addLuminarias" class="customButtonColor textS+" mat-button (click)="newZone()">{{this.localiser.get("button.create")}}</button>
      <button *ngIf="zonaEdit != undefined" class="customButtonColor textS+" mat-button (click)="updateZone()">{{this.localiser.get("button.update")}}</button>
    </div>
  </div>

</div>
